var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDifficultyLevelActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97357 1.72434L11.1978 4.28691L14.0832 4.62686C15.9213 4.84342 16.659 7.05063 15.3029 8.27611L13.1741 10.1998L13.7332 12.9725C14.0893 14.7388 12.1579 16.1029 10.5399 15.2278L8 13.8542L5.46012 15.2278C3.84212 16.1029 1.91068 14.7388 2.26682 12.9725L2.82586 10.1998L0.697086 8.27611C-0.659028 7.05063 0.0787168 4.84342 1.91682 4.62686L4.80221 4.28691L6.02643 1.72434C6.8063 0.0918859 9.1937 0.0918854 9.97357 1.72434Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0135 2.16985C7.40343 1.35362 8.59713 1.35362 8.98707 2.16985L10.2113 4.73242C10.3698 5.06426 10.6935 5.29289 11.0672 5.33691L13.9526 5.67686C14.8716 5.78514 15.2405 6.88874 14.5624 7.50148L12.4336 9.42518C12.158 9.6743 12.0343 10.0442 12.1067 10.4033L12.6658 13.1759C12.8438 14.0591 11.8781 14.7412 11.0691 14.3036L8.52925 12.93C8.20034 12.7521 7.80022 12.7521 7.47132 12.93L4.93144 14.3036C4.12244 14.7412 3.15672 14.0591 3.33479 13.1759L3.89384 10.4033C3.96623 10.0442 3.84259 9.6743 3.56692 9.42518L1.43814 7.50148C0.760086 6.88874 1.12896 5.78514 2.04801 5.67686L4.9334 5.33691C5.30704 5.29289 5.63074 5.06426 5.78928 4.73242L7.0135 2.16985Z",
    fill: "url(#paint0_linear_376_3116)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_376_3116",
    x1: 8.00028,
    y1: 1.55768,
    x2: 8.00028,
    y2: 14.4397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2A300"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifficultyLevelActive);
export default __webpack_public_path__ + "static/media/difficulty-level_active.1fef9ec3607e582d901f28315d7218e5.svg";
export { ForwardRef as ReactComponent };